// extracted by mini-css-extract-plugin
export default {"wrapper":"UserPosts_wrapper__+-N25","breadcrumbs":"UserPosts_breadcrumbs__xcCex"};